// extracted by mini-css-extract-plugin
module.exports = {"table":"Styles_table__3c_pt"};